export enum HorizontalAlignments
{
	Center = 'center',
	Right = 'right',
	Left = 'left'
}